import { ActionDataType } from '../_reducer/types';
import { searchActionsTypes } from './search.action';

export interface SearchReducerTypes {
  properties: Array<any>;
}

const initialState: SearchReducerTypes = {
  properties: []
};

const SearchReducer = (state = initialState, action: ActionDataType) => {
  switch (action.type) {
    case searchActionsTypes.SET_PROPERTIES:
      return {
        ...state,
        properties: action.data
      };
    default:
      return state;
  }
};
export default SearchReducer;
